import { Injectable } from '@angular/core'
import { AppStorageService } from './app-storage.service'

@Injectable({
  providedIn: 'root',
})
export class FlagStorageService {

  private readonly prefix = 'flags';

  constructor(private readonly appStorageService: AppStorageService) {
  }

  isEnabled(key: string): boolean {
    this.appStorageService.changePrefix(this.prefix);
    return this.appStorageService.get(key) === "true";
  }

  set(key: string, value: boolean): void {
    this.appStorageService.changePrefix(this.prefix);
    this.appStorageService.set(key, value.toString());
  }

  clear(key: string): void {
    this.appStorageService.changePrefix(this.prefix);
    this.appStorageService.remove(key);
  }

  clearAll(): void {
    this.appStorageService.changePrefix(this.prefix);
    this.appStorageService.clearAllPrefixedItems();
  }

}

export class Flags {
  public static readonly MFA_WARNING_DISMISSED = 'mfa_warning_dismissed';
  public static readonly MFA_WARNING_DISMISSED_FOREVER = 'mfa_warning_dismissed_forever';
}
